import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 445px 1fr;
	margin: 0px auto;
	width: 100%;
	max-width: 1235px;
`;

export const Section = styled.div`
	padding: 10px 16px;
`;

export const SectionCheckbox = styled.div`
	display: flex;
	align-items: center;
	gap: 17px;
	margin: 21px 0 16px;
`;

export const SectionContainer = styled.div`
	display: flex;
	margin-top: 21px;
`;
